module.exports = __webpack_public_path__ + "static/media/gotoiconOrange.491d66c0.svg";